export const GROUPE = 'Groupe';
export const ENSEIGNE = 'Enseigne';
export const POINT_VENTE = 'PointVente';
export const TYPOLOGIE = [
  { value: ENSEIGNE, libelle: 'enseigne' },
  { value: POINT_VENTE, libelle: 'pointVente' },
  { value: GROUPE, libelle: 'groupe' },
];
export const SOUS_TYPE_AUCUN = 'Aucun';
export const SOUS_TYPE_CONCURRENT = 'Concurrent';
export const SOUS_TYPE_CONFRERE = 'Confrere';
export const WITHOUT_LOGO = 'NON';
export const TYPE_CLIENT = 'Client';
export const TYPOLOGIE_AUCUN = 'Aucun';
export const TYPE_FOURNISSEUR = 'Fournisseur';
